import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../redux/store";
import { useForm } from "react-hook-form";
import { fetchMyCollection, fetchUser, postMyGift } from "../redux/lounges/slice";
import { selectLounges } from "../redux/lounges/selectors";
import { LoungeHeader } from "../components/LoungeHeader";
import { MobileLoungeHeader } from "../components/MobileLoungeHeader";
import PureModal from "react-pure-modal";
import "react-pure-modal/dist/react-pure-modal.min.css";
import { StoreTabs } from "../components/StoreTabs";
import { MyCollectionResults } from "../components/MyCollectionResults";
import {
  getOwnedCollectionCreditBalance,
  getOwnedCollectionItems,
} from "../utils/myCollectionSearch";
import { useLoungeSessionExpired } from "../utils/loungeSession";

type FormData = {
  Id: number;
  UserName: string;
};

const MyCollection = () => {
  const dispatch = useAppDispatch();
  const { myCollectionItem, userItem, status } = useSelector(selectLounges);
  const {
    register,
    setValue,
    handleSubmit,
  } = useForm<FormData>();
  const [modal, setModal] = useState(false);
  const [Id, setId] = useState<number | any>("");
  const [UserName, setUserName] = useState<any | string>("");

  const sessionExpired = useLoungeSessionExpired();
  const ownedItems = useMemo(
    () => getOwnedCollectionItems(myCollectionItem),
    [myCollectionItem]
  );
  const creditBalance = getOwnedCollectionCreditBalance(myCollectionItem);

  useEffect(() => {
    dispatch(fetchMyCollection());
  }, [dispatch]);

  useEffect(() => {
    setValue("Id", Id);
  }, [Id, setValue]);
  useEffect(() => {
    setValue("UserName", UserName);
  }, [UserName, setValue]);

  const searchFriend = (key: any) => {
    if (String(key || "").length > 0) {
      dispatch(fetchUser({ key }));
    }
  };

  const myGift = (id: any) => {
    setModal(true);
    setId(id);
  };

  const onSubmit = (data: any) => {
    window.scrollTo(0, 0);
    setModal(false);
    dispatch<any>(postMyGift(data)).then(() => {
      dispatch(fetchMyCollection());
    });
  };

  return (
    <>
      <div className="mid-main">
        <div className="container">
          <div className="mid-sec mwstore-page-bg">
            <LoungeHeader />
            <MobileLoungeHeader />
            <div className="mwstore-mid-bg">
              <StoreTabs />
              <div className="MW-buy-sec">
                <div className="container p-0">
                  <div className="row">
                    <div className="buy-m">
                      <div className="mws-mid-sec mb-2">
                        <h5 className="mid-head">My Collection</h5>
                      </div>

                      <MyCollectionResults
                        items={ownedItems}
                        status={status}
                        creditBalance={creditBalance}
                        sessionExpired={sessionExpired}
                        onGift={myGift}
                      />

                      <PureModal
                        header="Gift To MW Friend"
                        isOpen={modal}
                        closeButton={<i className="fa fa-close my-b" />}
                        closeButtonPosition="bottom"
                        onClose={() => {
                          setModal(false);
                          return true;
                        }}
                      >
                        <form
                          className="space-y-6"
                          onSubmit={handleSubmit(onSubmit)}
                          method="POST"
                        >
                          <div style={{ position: "fixed", top: "2.7rem" }}>
                            <input
                              type="text"
                              className="inp"
                              placeholder="Search MW Friend"
                              {...register("UserName")}
                              onChange={(e) => searchFriend(e.target.value)}
                            />

                            <input type="hidden" {...register("Id")} />

                            <div
                              className="mw-post text-center"
                              style={{
                                position: "fixed",
                                right: "30px",
                                top: "50px",
                              }}
                            >
                              <input
                                className="MW-btn"
                                type="Submit"
                                value="Submit"
                                style={{ padding: "0.2rem 0.7rem" }}
                              />
                            </div>
                          </div>

                          {userItem.length > 0 ? (
                            <ul
                              style={{
                                height: "10rem",
                                marginTop: "2rem",
                              }}
                            >
                              {userItem.map((item: any) => (
                                <li
                                  key={item?.id ?? item?.value}
                                  onClick={() => setUserName(item.value)}
                                  style={{
                                    padding: "10px 0px 5px 0px",
                                    borderBottom: "1px solid #000",
                                    cursor: "pointer",
                                  }}
                                >
                                  {item.value}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <ul
                              style={{
                                height: "auto",
                                marginTop: "1rem",
                              }}
                            />
                          )}
                        </form>
                      </PureModal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyCollection;
